<template>
  <div>
    <div class="box">
      <div class="title">头像</div>
      <img :src="imgUrl" alt="" />
    </div>
    <div class="box">
      <div class="title">用户名</div>
      <el-input
        type="text"
        placeholder="请输入内容"
        v-model="info.name"
        maxlength="10"
        show-word-limit
        size="mini"
        disabled
      >
      </el-input>
    </div>
    <div class="box">
      <div class="title">角色</div>
      <p>普通用户（查看收藏各类资讯）</p>
      <p style="color:#db0b0b">超级管理员可以设置各用户的角色；一个用户可以拥有多个角色。</p>
    </div>
    <div class="box">
      <div class="title">密码</div>
      <div class="edit" @click="dialogVisible = true">修改密码</div>
    </div>
    <el-dialog title="修改密码" :visible.sync="dialogVisible" width="30%">
      <resetPwd @closeEmit='close'/>
    </el-dialog>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/api.js";
import resetPwd from "./resetPwd";
export default {
  data() {
    return {
      text: "",
      info: {},
      imgUrl: "",
      dialogVisible: false,
      password: "",
    };
  },
  created() {
    this._getUserInfo();
  },
  methods: {
    _getUserInfo() {
      getUserInfo().then((res) => {
        this.info = res.data.data;
        this.imgUrl = require(`@/assets/defaultBucket/${res.data.data.avatar}.jpg`);
      });
    },
    close(val){
      this.dialogVisible = val
    }
  },
  components:{
    resetPwd
  }
};
</script>

<style scoped lang="scss">
.box {
  margin-bottom: 20px;
  .title {
    color: #000;
    font-weight: 600;
  }
  img {
    margin: 10px 0;
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .el-input {
    width: 350px;
    margin: 10px 0;
  }
  .edit {
    width: 80px;
    height: 30px;
    line-height: 30px;
    margin: 10px 0;
    text-align: center;
    border: 1px solid #0d6ec4;
    border-radius: 4px;
    color: #0d6ec4;
    cursor: pointer;
  }
}
</style>
